const isUndefined = (value: any): value is undefined => {
  return value === undefined;
};

export default isUndefined;
